import { Heart, MessageCircle, Users, Search, Sparkles, Star } from "lucide-react";
import { Button } from "./ui/button";

const ILLUSTRATIONS = {
  noProfiles: {
    icon: Search,
    title: { fr: "Plus de profils", en: "No more profiles" },
    description: { fr: "Modifiez vos filtres ou revenez plus tard !", en: "Adjust your filters or come back later!" },
    color: "text-pink-500",
    bg: "bg-pink-500/20"
  },
  noMatches: {
    icon: Heart,
    title: { fr: "Pas encore de matchs", en: "No matches yet" },
    description: { fr: "Continuez à liker des profils pour trouver l'amour !", en: "Keep liking profiles to find your match!" },
    color: "text-red-500",
    bg: "bg-red-500/20"
  },
  noMessages: {
    icon: MessageCircle,
    title: { fr: "Pas de messages", en: "No messages" },
    description: { fr: "Vos conversations apparaîtront ici", en: "Your conversations will appear here" },
    color: "text-blue-500",
    bg: "bg-blue-500/20"
  },
  noLikes: {
    icon: Sparkles,
    title: { fr: "Pas encore de likes", en: "No likes yet" },
    description: { fr: "Les personnes qui vous likent apparaîtront ici", en: "People who like you will appear here" },
    color: "text-yellow-500",
    bg: "bg-yellow-500/20"
  },
  noFavorites: {
    icon: Star,
    title: { fr: "Pas encore de favoris", en: "No favorites yet" },
    description: { fr: "Ajoutez des profils en favoris pour les retrouver facilement", en: "Add profiles to favorites to find them easily" },
    color: "text-yellow-500",
    bg: "bg-yellow-500/20"
  },
  noResults: {
    icon: Users,
    title: { fr: "Aucun résultat", en: "No results" },
    description: { fr: "Essayez avec d'autres critères", en: "Try with different criteria" },
    color: "text-purple-500",
    bg: "bg-purple-500/20"
  }
};

export default function EmptyState({ 
  type = "noProfiles", 
  language = "fr",
  action,
  actionLabel 
}) {
  const config = ILLUSTRATIONS[type] || ILLUSTRATIONS.noProfiles;
  const Icon = config.icon;
  
  return (
    <div className="flex flex-col items-center justify-center text-center p-8 min-h-[300px]">
      {/* Animated icon container */}
      <div className={`w-24 h-24 rounded-full ${config.bg} flex items-center justify-center mb-6 animate-pulse`}>
        <Icon className={`w-12 h-12 ${config.color}`} />
      </div>
      
      {/* Decorative elements */}
      <div className="relative mb-4">
        <div className="absolute -top-2 -left-8 w-3 h-3 bg-primary/30 rounded-full animate-bounce" style={{ animationDelay: "0s" }} />
        <div className="absolute -top-4 left-4 w-2 h-2 bg-pink-500/30 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }} />
        <div className="absolute -top-1 left-12 w-4 h-4 bg-yellow-500/30 rounded-full animate-bounce" style={{ animationDelay: "0.4s" }} />
      </div>
      
      <h3 className="font-heading text-2xl text-white mb-2">
        {config.title[language]}
      </h3>
      
      <p className="text-muted-foreground max-w-xs mb-6">
        {config.description[language]}
      </p>
      
      {action && (
        <Button onClick={action} className="rounded-full">
          {actionLabel || (language === 'fr' ? 'Réessayer' : 'Try again')}
        </Button>
      )}
    </div>
  );
}
